import { createSelector } from "reselect";
import { initialState } from "./reducer";

const reducerState = (state) => state.UserMgmt || initialState;

const makeUserMgmtSelectField = (field) =>
  createSelector(reducerState, (userMgmtState) => userMgmtState[field]);

export { reducerState, makeUserMgmtSelectField };
